import React, { Component } from 'react';

import {
    Collapse,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';

import {
    ExpandLess,
    ExpandMore,
} from '@material-ui/icons';

import * as Icon from '@material-ui/icons';

import {
    withStyles,
} from '@material-ui/core/styles';

import {
    getConfigValue,
    getTxt,
} from 'global/appGlobal';

import {
    addAuthListener,
    authInfo,
    initFromCookie,
    logout,
} from 'global/auth';

import CreatedByFooter from './CreatedByFooter';


const styles = theme => ({
    root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100vh',
    minHeight: '100vh',
    maxHeight: '100vh',
    padding: 0,
    background:
        'linear-gradient(165deg, #123A61 0%, #0B5670 62%, #0E7490 145%)',
    color: '#FFFFFF',
    opacity: 1,
    overflow: 'hidden',
    boxSizing: 'border-box',
},

    navigation: {
        flex: '1 1 auto',
        minHeight: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: theme.spacing.unit,
        boxSizing: 'border-box',

        '&::-webkit-scrollbar': {
            width: 6,
        },

        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },

        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(255, 255, 255, 0.22)',
            borderRadius: 999,
        },

        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.34)',
        },

        scrollbarWidth: 'thin',
        scrollbarColor:
            'rgba(255, 255, 255, 0.22) transparent',
    },

    drawerHeader: {
        ...theme.mixins.toolbar,
        minHeight: 64,
        marginBottom: theme.spacing.unit * 1.5,
        flex: '0 0 auto',
    },

    nested: {
        paddingLeft: theme.spacing.unit * 2,
    },

    menuIcon: {
        minWidth: theme.spacing.unit * 5,
        margin: 0,
        padding: 0,
        color: '#94EAF2',
    },

    menuText: {
        margin: 0,
        padding: 0,

        '& span': {
            color: 'rgba(255, 255, 255, 0.90)',
            fontSize: 13,
            fontWeight: 500,
        },
    },

    loginDivider: {
        backgroundColor: theme.palette.background.paper,
        opacity: 0.18,
    },
});


class MainMenu extends Component {
    static defaultProps = {
        schema: [],
    };

    state = {
        open: false,
        loginInfo: undefined,
        userMenuOpen: false,
        adminMenuOpen: false,
        paymentsMenuOpen: false,
        dashboardOpen: true,
    };

    constructor(props) {
        super(props);

        this.onMenuClick = this.onMenuClick.bind(this);
        this.trimName = this.trimName.bind(this);
    }

    componentWillMount() {
        initFromCookie(this.props.history);

        this.setState({
            loginInfo: authInfo.loginInfo,
        });

        addAuthListener((loginInfo) => {
            this.setState({
                loginInfo,
            });
        });
    }

    onLogout() {
        logout();
    }

    onMenuClick(path) {
        if (this.props.onClose) {
            this.props.onClose();
        }

        this.props.history.push(path);
    }

    trimName(name) {
        if (name && name.length > 8) {
            return `${name.substr(0, 5)}...`;
        }

        return name;
    }

    render() {
        const {
            classes,
            theme,
        } = this.props;

        const {
            adminMenuOpen,
            dashboardOpen,
            loginInfo,
            paymentsMenuOpen,
            userMenuOpen,
        } = this.state;

        const canUseDashboard =
            authInfo.isAgencyAdministrator() ||
            authInfo.isMasterBroker() ||
            authInfo.isBroker() ||
            authInfo.isSubBroker();

        const canUseManagementDashboard =
            authInfo.isAgencyAdministrator() ||
            authInfo.isMasterBroker();

        const canUseOperationalDashboard =
            authInfo.isBroker() ||
            authInfo.isSubBroker();

        const canUseBrokerArea =
            authInfo.isAgencyAdministrator() ||
            authInfo.isMasterBroker() ||
            authInfo.isBroker();

        const canUseReports =
            authInfo.isAgencyAdministrator() ||
            authInfo.isMasterBroker() ||
            authInfo.isBroker();

        const canUseAdministration =
            authInfo.isAgencyAdministrator() ||
            authInfo.isMasterBroker();

        return (
            <div
                id="mainMenu"
                className={classes.root}
            >
                <div className={classes.navigation}>
                    <div className={classes.drawerHeader} />

                    <List>
                        {loginInfo && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.setState({
                                        userMenuOpen: !userMenuOpen,
                                    });
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.AccountCircle />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={this.trimName(
                                        loginInfo.userInfo.displayName
                                    )}
                                    className={classes.menuText}
                                />

                                {userMenuOpen
                                    ? <ExpandLess />
                                    : <ExpandMore />
                                }
                            </ListItem>
                        )}

                        {loginInfo && (
                            <Collapse
                                in={userMenuOpen}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    {(authInfo.isMasterBroker() ||
                                        authInfo.isBroker() ||
                                        authInfo.isSubBroker()) &&
                                        !authInfo.isAgencyAdministrator() && (
                                            <ListItem
                                                button
                                                onClick={() => {
                                                    this.onMenuClick(
                                                        `/brokers/edit/${
                                                            loginInfo
                                                                .userInfo
                                                                .user_id
                                                        }`
                                                    );
                                                }}
                                            >
                                                <ListItemIcon
                                                    className={
                                                        classes.menuIcon
                                                    }
                                                >
                                                    <Icon.Settings />
                                                </ListItemIcon>

                                                <ListItemText
                                                    inset
                                                    primary={getTxt(
                                                        'My Profile'
                                                    )}
                                                    className={
                                                        classes.menuText
                                                    }
                                                />
                                            </ListItem>
                                        )
                                    }

                                    {authInfo.isAgencyAdministrator() && (
                                        <ListItem
                                            button
                                            onClick={() => {
                                                this.onMenuClick(
                                                    '/admin/profile'
                                                );
                                            }}
                                        >
                                            <ListItemIcon
                                                className={classes.menuIcon}
                                            >
                                                <Icon.Settings />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                primary={getTxt(
                                                    'My Profile'
                                                )}
                                                className={classes.menuText}
                                            />
                                        </ListItem>
                                    )}

                                    {authInfo.isCompany() && (
                                        <ListItem
                                            button
                                            onClick={() => {
                                                this.onMenuClick(
                                                    '/company/profile'
                                                );
                                            }}
                                        >
                                            <ListItemIcon
                                                className={classes.menuIcon}
                                            >
                                                <Icon.Settings />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                primary={getTxt(
                                                    'My Profile'
                                                )}
                                                className={classes.menuText}
                                            />
                                        </ListItem>
                                    )}

                                    {authInfo.isCustomer() && (
                                        <ListItem
                                            button
                                            onClick={() => {
                                                this.onMenuClick(
                                                    '/customer/profile'
                                                );
                                            }}
                                        >
                                            <ListItemIcon
                                                className={classes.menuIcon}
                                            >
                                                <Icon.Settings />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                primary={getTxt(
                                                    'My Profile'
                                                )}
                                                className={classes.menuText}
                                            />
                                        </ListItem>
                                    )}
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={this.onLogout}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.ExitToApp />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Logout',
                                                '#pmd83nd'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            </Collapse>
                        )}

                        <Divider
                            key="login-divider"
                            className={classes.loginDivider}
                            style={{
                                marginBottom:
                                    theme.spacing.unit * 2,
                            }}
                        />

                        {canUseDashboard && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.setState({
                                        dashboardOpen: !dashboardOpen,
                                    });
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.Dashboard />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt('Dashboard')}
                                    className={classes.menuText}
                                />

                                {dashboardOpen
                                    ? <ExpandLess />
                                    : <ExpandMore />
                                }
                            </ListItem>
                        )}

                        {canUseManagementDashboard && (
                            <Collapse
                                in={dashboardOpen}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/dashboard/management'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Dashboard />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Management')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/dashboard/operational'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Dashboard />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Operativa')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            </Collapse>
                        )}

                        {canUseOperationalDashboard && (
                            <Collapse
                                in={dashboardOpen}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/dashboard/operational'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Dashboard />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Operativa')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            </Collapse>
                        )}

                        {!authInfo.isCustomer() && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.onMenuClick('/customers/all');
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.AccountBox />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt(
                                        'Cliente',
                                        '#2q9257z'
                                    )}
                                    className={classes.menuText}
                                />
                            </ListItem>
                        )}

                        <ListItem
                            button
                            className={classes.nested}
                            onClick={() => {
                                this.onMenuClick('/requests/all');
                            }}
                        >
                            <ListItemIcon className={classes.menuIcon}>
                                <Icon.DirectionsCar />
                            </ListItemIcon>

                            <ListItemText
                                inset
                                primary={getTxt(
                                    'Richieste',
                                    '#60613w6'
                                )}
                                className={classes.menuText}
                            />
                        </ListItem>

                        <ListItem
                            button
                            className={classes.nested}
                            onClick={() => {
                                this.onMenuClick('/contracts/all');
                            }}
                        >
                            <ListItemIcon className={classes.menuIcon}>
                                <Icon.Class />
                            </ListItemIcon>

                            <ListItemText
                                inset
                                primary={getTxt(
                                    'Polizze',
                                    '#cmuc3y8'
                                )}
                                className={classes.menuText}
                            />
                        </ListItem>

                        <ListItem
                            button
                            className={classes.nested}
                            onClick={() => {
                                this.onMenuClick('/claims');
                            }}
                        >
                            <ListItemIcon className={classes.menuIcon}>
                                <Icon.Class />
                            </ListItemIcon>

                            <ListItemText
                                inset
                                primary={getTxt('Claims')}
                                className={classes.menuText}
                            />
                        </ListItem>

                        {!authInfo.isCustomer() &&
                            !authInfo.isSubBroker() &&
                            !authInfo.isBroker() && (
                                <ListItem
                                    button
                                    className={classes.nested}
                                    onClick={() => {
                                        this.onMenuClick(
                                            '/company/search'
                                        );
                                    }}
                                >
                                    <ListItemIcon
                                        className={classes.menuIcon}
                                    >
                                        <Icon.Class />
                                    </ListItemIcon>

                                    <ListItemText
                                        inset
                                        primary={getTxt('Companies')}
                                        className={classes.menuText}
                                    />
                                </ListItem>
                            )
                        }

                        {canUseBrokerArea && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.onMenuClick('/brokers');
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.Person />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt('Collaborate')}
                                    className={classes.menuText}
                                />
                            </ListItem>
                        )}

                        {!authInfo.isCustomer() && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.setState({
                                        paymentsMenuOpen:
                                            !paymentsMenuOpen,
                                    });
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.VerifiedUser />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt('Payments')}
                                    className={classes.menuText}
                                />

                                {paymentsMenuOpen
                                    ? <ExpandLess />
                                    : <ExpandMore />
                                }
                            </ListItem>
                        )}

                        <Collapse
                            in={paymentsMenuOpen}
                            timeout="auto"
                            unmountOnExit
                        >
                            {canUseBrokerArea && (
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/brokers/payments/all'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Payment />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Broker')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            )}

                            {canUseAdministration && (
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/companies/payments/all'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Payment />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Company')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            )}

                            <List
                                component="div"
                                disablePadding
                            >
                                <ListItem
                                    button
                                    onClick={() => {
                                        this.onMenuClick(
                                            '/customers/payments/all'
                                        );
                                    }}
                                >
                                    <ListItemIcon
                                        className={classes.menuIcon}
                                    >
                                        <Icon.Payment />
                                    </ListItemIcon>

                                    <ListItemText
                                        inset
                                        primary={getTxt('Customer')}
                                        className={classes.menuText}
                                    />
                                </ListItem>
                            </List>
                        </Collapse>

                        {canUseReports && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.onMenuClick('/reports');
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.Print />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt(
                                        'Reports',
                                        '#8ioh2e8'
                                    )}
                                    className={classes.menuText}
                                />
                            </ListItem>
                        )}

                        {canUseReports &&
                            getConfigValue('partnerAgencies').length > 0 && (
                                <ListItem
                                    button
                                    className={classes.nested}
                                    onClick={() => {
                                        this.onMenuClick(
                                            '/shared-search'
                                        );
                                    }}
                                >
                                    <ListItemIcon
                                        className={classes.menuIcon}
                                    >
                                        <Icon.Search />
                                    </ListItemIcon>

                                    <ListItemText
                                        inset
                                        primary={getTxt(
                                            'Ricerca Condivisa'
                                        )}
                                        className={classes.menuText}
                                    />
                                </ListItem>
                            )
                        }

                        {canUseAdministration && (
                            <ListItem
                                button
                                className={classes.nested}
                                onClick={() => {
                                    this.setState({
                                        adminMenuOpen:
                                            !adminMenuOpen,
                                    });
                                }}
                            >
                                <ListItemIcon className={classes.menuIcon}>
                                    <Icon.VerifiedUser />
                                </ListItemIcon>

                                <ListItemText
                                    inset
                                    primary={getTxt('Admin')}
                                    className={classes.menuText}
                                />

                                {adminMenuOpen
                                    ? <ExpandLess />
                                    : <ExpandMore />
                                }
                            </ListItem>
                        )}

                        {canUseAdministration && (
                            <Collapse
                                in={adminMenuOpen}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/conti_transito'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Payment />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Contabilità'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/real_insurance_types'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Class />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Real Ins. Types',
                                                '#aj2smh5'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/insurance_types'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Class />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'User Ins. Types',
                                                '#1pcx1po'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/payment_types'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Payment />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'User Paym. Types'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/guaranty_types'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Person />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Guaranty Types',
                                                '#d74y30s'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/contract_items_types'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Class />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Movement Types'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/dictionaries'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Subject />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Dictionaries',
                                                '#9n43tdr'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/email_templates'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Email />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Email Templates'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/reports_header'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Settings />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Dati Aziendali'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/settings'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Settings />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt('Settings')}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>

                                <List
                                    component="div"
                                    disablePadding
                                >
                                    <ListItem
                                        button
                                        onClick={() => {
                                            this.onMenuClick(
                                                '/changelog'
                                            );
                                        }}
                                    >
                                        <ListItemIcon
                                            className={classes.menuIcon}
                                        >
                                            <Icon.Subject />
                                        </ListItemIcon>

                                        <ListItemText
                                            inset
                                            primary={getTxt(
                                                'Change Log'
                                            )}
                                            className={classes.menuText}
                                        />
                                    </ListItem>
                                </List>
                            </Collapse>
                        )}
                    </List>

                    <Divider
                        key="menu-footer-divider"
                        className={classes.loginDivider}
                    />
                </div>

                <CreatedByFooter />
            </div>
        );
    }
}


export default withStyles(
    styles,
    {
        withTheme: true,
    }
)(MainMenu);